import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.starts-with.js";
import cookie from 'cookie';
export default (function (context, inject) {
  var plugin = {
    all: function all() {
      var cookieStr = process.client ? document.cookie : context.req.headers.cookie;
      return cookie.parse(cookieStr || '') || {};
    },
    set: function set(key, value) {
      if (process.server && !context.res) {
        return;
      }
      var _key = key;
      var _value = value;
      var _options = {
        path: '/'
      };
      if (typeof _value === 'undefined' || _value === null) {
        _options.maxAge = -1;
      }
      var serializedCookie = cookie.serialize(_key, _value, _options);
      if (process.client) {
        // Set in browser
        document.cookie = serializedCookie;
      } else if (process.server && context.res && !context.res.headersSent) {
        // Send Set-Cookie header from server side
        var cookies = context.res.getHeader('Set-Cookie') || [];
        cookies.unshift(serializedCookie);
        context.res.setHeader('Set-Cookie', cookies.filter(function (v, i, arr) {
          return arr.findIndex(function (val) {
            return val.startsWith(v.substr(0, v.indexOf('=')));
          }) === i;
        }));
      }
      return value;
    },
    get: function get(key) {
      if (process.server && !context.req) {
        return;
      }
      var _key = key;
      var cookies = this.all();
      var value = cookies[_key] ? decodeURIComponent(cookies[_key]) : undefined;
      return value;
    },
    remove: function remove(key) {
      this.set(key, undefined);
    }
  };
  inject('cookies', plugin);
});